/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Mcp_DetailInputs */

const en_common_header_ai_mcp_detail = /** @type {(inputs: Common_Header_Ai_Mcp_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP integration status`)
};

const zh_common_header_ai_mcp_detail = /** @type {(inputs: Common_Header_Ai_Mcp_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 集成状态`)
};

/**
* | output |
* | --- |
* | "MCP integration status" |
*
* @param {Common_Header_Ai_Mcp_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_mcp_detail = /** @type {((inputs?: Common_Header_Ai_Mcp_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Mcp_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_mcp_detail(inputs)
	return zh_common_header_ai_mcp_detail(inputs)
});
export { common_header_ai_mcp_detail as "common.header.ai.mcp.detail" }